// import variants2 from './variants2'
import { executeHttpCall } from '@/services/httpClientHelper.js'
import { submitFile2SAS } from '@/services/httpClientHelper.js'
import navistarSpecification from '@/assets/json/navistarSpecification_20221005T123000Z.json'

const variantFamilies = {
  namespaced: true,
  state: () => ({
    families: {
      selected: [],
      vehicleOptions: [],
      engineOptions: [],
      loading: false,
      error: false
    }
  }),
  mutations: {
    // Families
    selectedFamiliesNew (state, value) {
      state.families.selected = value
    },
    familyVehicleOptions (state, value) {
      state.families.vehicleOptions = value
    },
    familyEngineOptions (state, value) {
      state.families.engineOptions = value
    },
    familiesLoading (state, value) {
      state.families.loading = value
    },
    familiesLoadingError (state, value) {
      state.families.error = value
    },
    // Common
    resetSelected (state) {
      state.families.selected = []
    },
    reset (state) {
      state.families = {
        selected: [],
        vehicleOptions: [],
        engineOptions: [],
        loading: [],
        error: false
      }
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    }
  },
  getters: {
    // getAllSelections: (state, getters) => {
    //   return {
    //     variants2: getters['variants2/getAllSelections'],
    //   }
    // }
    getFamiliesOptions: (state, getters, rootState, rootGetters) => {
      var result =  (rootGetters['population/getProductType'] === 'VEHICLE'
        ? state.families.vehicleOptions : state.families.engineOptions)
        .map(x => {
          return {
            id: x.Family,
            label: x.FpcFamilyDescGUI
          }
        })
      if ((rootGetters['population/getProductType']?.name === 'NAVISTAR')){
        result = navistarSpecification.FeatureGroups.map(x => {
          return {
            id: x.FeatureGroup,
            label: x.FeatureGroup + ' ' + x.Description.replaceAll(/\S*/g, word => `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`)
          }
        })
      }
      else if ((rootGetters['population/getProductType']?.name === 'MAN')){
          result = []
      }
      return result
    },
    isSelected: (state) => {
      return state.families.selected.length > 0 
    },
    getAllSelections: (state) => {
      return {
        families: state.families.selected
      }
    }
  },
  actions: {
    // loadStateFromFile ({ commit, dispatch }, data) {
    //   dispatch('variants2/loadStateFromFile', data.variants2)
    // },
    resetSelections: ({ commit }) => {
      commit('reset')
      // commit('variants2/resetSelected')
      commit('setSelectedReportType', null, { root: true })
    },
    reset: ({ commit }) => {
      commit('reset')
      // commit('variants2/reset')
      commit('setSelectedReportType', null, { root: true })
    },
    loadStateFromFile ({ commit, dispatch }, data) {
      console.log('data----------------------' + data)
      commit('overwriteSelected', data)
      commit('selectedFamiliesNew', data)
    },
    setSelectedFamiliesNew ({ dispatch, commit, state, getters }, value) {
      const selected = state.families.selected
      if (selected.length < value.length) {
        if(value[0] === 0 && selected.length === 0){
          //IF we implement a select all in the variant family
          // const families = getters.getFamiliesOptions
          // dispatch('addExecutionsByFamily', families)
        }
        else{
          const difference = value.filter(x => !selected.includes(x))
          const family = getters.getFamiliesOptions.find(x => x.id === difference[0])
          // dispatch('addExecutionsByFamily', family)
        }
      } 
      commit('selectedFamiliesNew', value)
    },
    getFamilies ({ commit, state, rootState, dispatch }) {
      const productType = rootState.population.productType
      if (!productType) return

      commit('familiesLoadingError', false)
      const dataLoaded =
        (productType === 'VEHICLE' && state.families.vehicleOptions.length > 0) ||
        (productType === 'ENGINES' && state.families.engineOptions.length > 0)
      if (dataLoaded) return

      commit('familiesLoading', true)
      const params = {
        resultFile: 'GetFpcFa',
        _program: 'GetFpcFamilies',
        productType: productType
      }
      executeHttpCall(params, null).then(result => {
        if (productType === 'VEHICLE') {
          commit('familyVehicleOptions', result)
        }
        if (productType === 'ENGINES') {
          commit('familyEngineOptions', result)
        }
        const families = state.families

        if (families.selected.length > 0) {
          dispatch('addExecutionsByFamily', families.selected)
        }
      }).catch(error => {
        console.error('getFpcFamilies: ', error)
        commit('familiesLoadingError', true)
      }).finally(() => {
        commit('familiesLoading', false)
      })
    },
    removeIdFromFamilySelection ({ commit, state }, id) {
      commit('selectedFamiliesNew', state.families.selected.filter(x => x !== id))
    }
  }
}
export default variantFamilies
